module.exports = __webpack_public_path__ + "img/bms_conectado_SMALL.9ddb4f7f.jpg";